import ResumeItem from "@/common/components/ResumeItem";
import { formatCurrency } from "@/common/utils/formatters";
import { branchesEquipmentsConsumptionsTotalizerColumns } from "@/features/privateCompanies/constants/totals/branchesEquipmentsConsumptionsTotalizerColumns.constant";
import { ClientCompanyBranchesEquipmentsConsumptionsTotalizerBranchData } from "@/features/privateCompanies/types/clientCompanyBranchesEquipmentsConsumptionsTotalizer.type";
import { Building2Icon } from "lucide-react";
import EquipmentRow from "./EquipmentRow";

interface BranchRowProps {
  branch: ClientCompanyBranchesEquipmentsConsumptionsTotalizerBranchData;
}

const BranchRow = ({
  branch,
}: BranchRowProps) => {
  return (
    <tbody key={branch.id}>
      <tr>
        <td colSpan={branchesEquipmentsConsumptionsTotalizerColumns.length} className="p-0 pt-3 print:pt-0 print:border-x print:border-neutral-300">
          <div
            className={`
              flex items-center justify-between gap-8 p-3 bg-white-200/20 rounded-t-lg
              print:rounded-t-none print:bg-neutral-300
            `}
          >
            <div className="flex items-center gap-3">
              <Building2Icon strokeWidth={1.5} size={22} className="text-warning print:text-black" />

              <ResumeItem
                label="Filial"
                value={branch.display_name}
                className="text-warning print:font-medium"
                labelClassName="text-xs print:text-black"
                valueClassName="text-sm print:text-black"
              />
            </div>
          </div>
        </td>
      </tr>

      {branch.equipments.map((equipment) => (
        <EquipmentRow
          key={equipment.id}
          equipment={equipment}
        />
      ))}

      <tr>
        <td colSpan={branchesEquipmentsConsumptionsTotalizerColumns.length} className="p-0 print:border-x print:border-neutral-200">
          <div className="flex items-center justify-between gap-8 p-3 bg-white-200/20 rounded-b-lg print:rounded-b-none print:bg-neutral-300/50 print:font-semibold">
            <p>
              Valor total da filial
            </p>

            <p>
              {(branch.total_value && formatCurrency(Number(branch.total_value))) || '--'}
            </p>
          </div>
        </td>
      </tr>
    </tbody>
  );
}

export default BranchRow;
